import React from "react";
import Layout from "./shared/Layout";

const Testimonials = () => {
  return (
    <Layout>
      <div>This is the Testimonials page</div>
    </Layout>
  );
};

export default Testimonials;